import styled from 'styled-components';

import {
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledContainerDiv = styled.div`
    width: 100%;
    max-width: 140px;
`;

export const StyledContentDiv = styled.div`
    flex: 1;
    padding: ${spaceMixin('xs')};
    border-left: 1px solid ${token('colors.gray300')};
    display: flex;
    flex-direction: column;
`;

export const StyledDiv = styled.div`
    display: flex;
    flex-direction: row;
    border: 1px solid ${token('colors.gray300')};
    border-radius: 4px;
    height: 140px;
`;
